<template>
  <div>
    <div class="d-flex justify-content-between">
      <div class="row">
        <div class="col-3">
          <div class="col-12">
            <SignaturesContainer
              :signatures="signatures"
              v-model="signatureSelected"
              :closable-sign="false"
              placeholder="Buscar Firma"
            />
            <h5 class="text-left">
              Por favor, haz click en la estampa que quieres posicionar
            </h5>
          </div>
        </div>
        <div class="col-9">
          <PdfViewport
            :default-page="defaultPage || 1"
            :closable-sign="false"
            :path="file.path"
            :name="file.name"
            :signatures="Object.values(signaturesDroppedData)"
            @loaded="$emit('loaded')"
            @page-click="onSignatureDropped"
            @signature-delete="onSignatureDelete"
            @signature-drag-end="onSignatureDragEnd"
            :signature-width="signatureWidth"
            :signature-height="signatureHeight"
            :signature-type="signatureType"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import WizardStep from '@/febos/chile/dnt/mixins/WizardStep';
import PdfViewport from '@/febos/global/pdf/components/PdfViewport';
import { SIGNATURE_TYPES } from '@/febos/global/pdf/config';
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';
import SignaturesContainer from '@/febos/chile/approvals/wizardFlow/components/SignaturesContainer';

const SIGNATURE_WIDTH = 150;
const SIGNATURE_HEIGHT = 50;

export default {
  mixins: [
    WizardStep
  ],
  components: {
    SignaturesContainer,
    PdfViewport
  },
  data() {
    return {
      isDroppingSignature: false,
      signatureSelected: undefined,
      actionsSelected: undefined,
      signaturesDroppedData: {},
      signatureWidth: SIGNATURE_WIDTH,
      signatureHeight: SIGNATURE_HEIGHT,
      signatureType: SIGNATURE_TYPES.DraggableSignature
    };
  },
  props: {
    file: {
      type: Object,
      required: true
    },
    signaturesDropped: {
      type: Object
    },
    steps: {
      type: Array
    }
  },
  computed: {
    defaultPage() {
      if (this.signaturesDroppedData && Object.values(this.signaturesDroppedData).length > 0) {
        return Object.values(this.signaturesDroppedData)[0].page || 1;
      }
      return 1;
    },
    signatures() {
      return Object.values(this.signaturesDroppedData)
        .map(({
          name, id, stepType, x, y, page
        }) => ({
          name,
          id,
          stepType,
          x,
          y,
          page
        }));
    },
    actions() {
      if (!this.step?.actions) {
        return [];
      }
      return this.step?.actions.map(({ id, action, ...resto }) => ({
        name: action,
        id: `${id}-${action}`,
        ...resto,
        isAction: true
      })).filter(({ id, positionRequired }) => (
        positionRequired && !this.signaturesDroppedData[id]
      ));
    }
  },
  watch: {
    signatureSelected(newValue, prevValue) {
      if (this.isDroppingSignature) {
        this.isDroppingSignature = false;
        return;
      }

      if (!newValue && prevValue) {
        const {
          [prevValue.id]: ignored,
          ...cleanSignaturesDropped
        } = this.signaturesDroppedData;
        this.signaturesDroppedData = cleanSignaturesDropped;
      }
    },
    signaturesDropped(newVal) {
      this.signaturesDroppedData = newVal;
    }
  },
  methods: {
    onSignatureDropped({ x, y }, page) {
      if (!this.signatureSelected) {
        return;
      }

      this.signaturesDroppedData = {
        ...this.signaturesDroppedData,
        [this.signatureSelected.id]: {
          ...this.signatureSelected,
          x,
          y,
          page
        }
      };
      this.$emit('sign-position', this.signaturesDroppedData[this.signatureSelected.id]);
      this.isDroppingSignature = true;
    },
    onSignatureDelete(signature) {
      this.$delete(this.signaturesDroppedData, signature.id);
    },
    onSignatureDragEnd({ x, y }, signature) {
      this.signatureSelected = signature;
      this.signaturesDroppedData = {
        ...this.signaturesDroppedData,
        [signature.id]: {
          ...signature,
          x,
          y
        }
      };
      this.$emit('sign-position', this.signaturesDroppedData[this.signatureSelected.id]);
    },
    async isValid() {
      const signatures = this.signatures
        .filter((signature) => signature.stepType !== StepTypes.OFFICE);
      if (signatures.length) {
        this.$bvToast.toast(
          'Debes ubicar todas las firmas!',
          {
            title: 'Error',
            variant: 'danger',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 2000
          }
        );
        return false;
      }
      return true;
    }
  },
  created() {
    this.signaturesDroppedData = this.signaturesDropped;
  }
};

</script>
<style>
.blocked {
  opacity: 0.5;
  pointer-events: none;
  cursor: none;
}
</style>
